<template>


  <b-col cols="12" v-if="type === 'R'">

    <b-row>

      <b-col class="d-flex flex-lg-column">

        <div class="main-card card p-2 h-100-header" id="container_pages">

          <div class="card-body" id="card-page">

            <b-row v-if="goBackTo !== ''">

              <router-link class="ml-3 text-secondary"
                           :to="{ name: goBackTo, query: checkLastQuery()}">
                <b-icon-arrow-left-circle class="mr-1"></b-icon-arrow-left-circle>
                {{ goBackTitle }}
              </router-link>

            </b-row>

            <b-row v-else-if="breadcrumb">
              <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
            </b-row>

            <transition mode="out-in"
                        enter-active-class="animated fadeIn">

              <div v-show="!busy">

                <transition mode="out-in"
                            enter-active-class="animated fadeIn">


                  <div>

                    <t-page-title v-if="title !== ''" :title="title">
                      <slot name="title-buttons"></slot>
                      <slot name="title"></slot>
                    </t-page-title>

                    <slot name="header"></slot>

                    <div v-html="report"></div>


                  </div>


                </transition>


              </div>
            </transition>


            <div class="container_loading_form" v-show="busy">

              <div class="container_loading_form_card">

                <div class="container-title-page" v-if="title !==''">
                  <div class="gradient flex-grow-1 title-page">
                    <div class="gradient element-80" style="height: 24px;"></div>
                  </div>
                </div>


                <div class="gradient element-60" style="height: 200px;"></div>

                <div class="gradient element-80"></div>


                <div class="gradient element-80"></div>

              </div>


            </div>


          </div>

        </div>

      </b-col>


    </b-row>

  </b-col>


  <div v-else-if="type === 'D' && !loaded" class="d-flex w-100 h-100-header justify-content-center align-items-center">

    <div class="loader-wrapper">
      <div class="loader">
        <div class="ball-pulse-sync">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>

  </div>

  <div v-else-if="type === 'D' && loaded" v-html="report" class="col-12 mt-4">

  </div>

</template>
<script>
import pageReportMixin from "@/mixins/page/pageReportMixin";

export default {
  name: 't-page-report',
  mixins: [pageReportMixin],
  data() {
    return {
      intervalRefresh: null,
      routeName: "",
    }
  },
  methods: {
    mountedPrepare() {

      if(this.type === 'D'){
        this.routeName = this.$route.name
      }

    },
    async mountedContinued() {

      if (this.intervalRefresh == null) {

        this.intervalRefresh = setInterval(async () => {

          if(this.$route.name !== this.routeName){
            clearInterval(this.intervalRefresh)
          }else{
            await this.mountedReport()
          }

        }, 120000)

      }

    },

    checkLastQuery() {
      return this.goBackTo === this.getLastPage.name ? this.getLastPage.query : null
    },

  },

  async mounted() {

    this.mountedPrepare()

    await this.mountedReport()

    await this.mountedContinued()


  },
  computed: {

    getLastPage() {
      return this.$store.getters.getLastPage
    }

  },
}
</script>
<style>
.container_loading_form_card .gradient {
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(to right, #fafafa 8%, #f4f4f4 38%, #fafafa 54%);
  background-size: 1000px 640px;

  position: relative;

}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 468px 0
  }
}
</style>
